// extracted by mini-css-extract-plugin
export default {"home-bar":"home-bar__40lV2","actions":"actions__psAkO","icon":"icon__dlylt","title":"title__MCZmI","notification":"notification__A1sIL"};